import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AnalyticsMetadata } from '../../occ/occ-models/occ-generated.models';
import { AnalyticsMetadataFacade } from '../facades';
import { AnalyticsMetadataSelectors } from '../store/selectors/user.selectors';
import { StateWithUser } from '../store/user-state';

@Injectable()
export class AnalyticsMetadataService implements AnalyticsMetadataFacade {
  constructor(private store: Store<StateWithUser>) {}

  getAnalyticsMetadata(): Observable<AnalyticsMetadata | undefined> {
    return this.store.pipe(
      select(AnalyticsMetadataSelectors.getAnalyticsMetadataLoaderState),
      filter((loaderState) => loaderState.success),
      map((loaderState) => loaderState.value)
    );
  }

  getAnalyticsMetadataLoading(): Observable<boolean> {
    return this.store.pipe(select(AnalyticsMetadataSelectors.getAnalyticsMetadataLoading));
  }

  getAnalyticsMetadataLoaded(): Observable<boolean> {
    return this.store.pipe(select(AnalyticsMetadataSelectors.getAnalyticsMetadataLoaded));
  }
}
